import { fetchingAPI, apiService } from '../../api'
import { setCurrentOrganization } from './currentOrganization.redux'
import { syncRbacFlags } from './currentUser.actions'

export const fetchCurrentOrganization = (organizationId) => {
  return async (dispatch) => {
    try {
      const organization = await fetchingAPI(
        `${apiService.core}/api/organizations/${organizationId}`,
        'GET',
        dispatch
      )
      dispatch(setCurrentOrganization(organization))
      // The rollout mode lives on the org, so the user's flags may need to follow it.
      dispatch(syncRbacFlags())
    } catch (err) {
      console.error(err)
    }
  }
}
